import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TagRecordCategoryEnum } from '../enums/tag-record-category.enum';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Tag DTO for nested create/update on parent records.
 */
export class TagDto {
  @TransformInt()
  id?: number;
  name?: string | null;
  recordCategory!: TagRecordCategoryEnum;
  description?: string | null;
  color?: string | null;
}
